// Por que no se pudo subir un archivo, dicho con lo que pasa de verdad (5.3).
//
// **Una sola frase para todos los fallos es el fallo.** El 2026-09-21 quedarse
// sin saldo se leia como «no te he entendido», y quien escribia se paso un rato
// reescribiendo una frase que no tenia nada malo (D6). Aqui pasa lo mismo con
// otro disfraz: «no he podido subirlo» vale igual para un archivo de 200 MB,
// para una sesion caducada y para el servicio caido, y **cada uno se arregla de
// una forma distinta**. Quien lo lee no puede saber cual le toca.
//
// Esto no interpreta: mira el codigo que devolvio el servidor, que es un dato.
// Lo que no reconoce cae en el mensaje de ultimo recurso, que **lleva dentro el
// error de verdad** en vez de taparlo.

import { RagApiError } from '@/services/ApiService'

const BY_STATUS: Record<number, string> = {
  400: 'brain.archivo.rechazado',
  401: 'brain.archivo.sin_sesion',
  403: 'brain.archivo.sin_sesion',
  413: 'brain.archivo.demasiado_grande',
}

export interface UploadFailure {
  key: string
  detail: string
}

export function uploadFailure(error: unknown): UploadFailure {
  const detail = error instanceof Error ? error.message : String(error)
  const status = error instanceof RagApiError ? error.status : undefined

  if (status !== undefined && BY_STATUS[status]) {
    return { key: BY_STATUS[status], detail }
  }
  // 5xx es el servicio; **sin `status` tambien**, porque una peticion que no
  // llega a salir no trae codigo y es el mismo problema para quien lo lee.
  if (status === undefined || status >= 500) {
    return { key: 'brain.archivo.sin_servicio', detail }
  }
  return { key: 'brain.archivo.no_se_pudo', detail }
}
